import { TabList, Tab } from 'react-aria-components';
import { Paragraph } from '@hungryroot/ramen';
import { productCategories } from '../../../categories/productCategories';
import { useProductCategories } from '../../../categories/useProductCategories';
import styles from './GroceryCategoryTabList.module.css';

type GroceryCategoryTabListProps = {
  selectedCategory: number;
};

export function GroceryCategoryTabList(props: GroceryCategoryTabListProps) {
  const { selectedCategory } = props;

  const { data: productCategoriesData } = useProductCategories();

  if (!productCategoriesData) {
    return null;
  }

  return (
    <TabList
      className={styles['tab-list']}
      aria-label="List of offered product categories"
    >
      {productCategoriesData.results.map((category) => {
        if (category.id === productCategories.Supplements) {
          return null;
        }

        return (
          <Tab
            className={styles['tab-list-item']}
            key={category.id}
            id={generateTabId(category.id)}
            data-selected={selectedCategory === category.id ? 'true' : null}
          >
            <Paragraph variant="caption">{category.name}</Paragraph>
          </Tab>
        );
      })}
    </TabList>
  );
}

export function generateTabId(categoryId: number) {
  return `product-category-tab-${categoryId}`;
}
